import Canvas from './Canvas';

export type ColorStop = [number, string];

interface GradientCanvasProps {
  gradientConfig?: ColorStop[];
}

// Create a 1x256 gradient to turn a grayscale heatmap into a colored one.
export class GradientCanvas extends Canvas {
  static config: ColorStop[] = [
    [0.4, 'blue'],
    [0.6, 'cyan'],
    [0.7, 'lime'],
    [0.8, 'yellow'],
    [1.0, 'red'],
  ];

  constructor({ gradientConfig }: GradientCanvasProps) {
    // Init the parent class, creating a 1x256 rectangular canvas.
    super({ width: 1, height: 256 });

    // Draw the gradient once.
    this._draw(gradientConfig);
  }

  private _draw(gradientConfig: ColorStop[] = GradientCanvas.config) {
    const ctx = this.ctx;

    if (ctx) {
      const width = this.getWidth();
      const height = this.getHeight();

      // Create the greyscale linear gradient that shows 256 pixels from white to black.
      const gradient = ctx.createLinearGradient(0, 0, 0, height);

      // Augment the gradient to be colored by the gradientConfig.
      gradientConfig.forEach((colorStop: ColorStop) => {
        gradient.addColorStop(...colorStop);
      });

      // Fill the gradientCanvas with the color adjusted gradient.
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);

      // Get the combined gradient data from the gradientCanvas.
      return ctx.getImageData(0, 0, width, height).data;
    }
  }
}

export default GradientCanvas;
